export function getMotePreview(): MotePreview {
  if (window.motePreview) {
    return window.motePreview
  }
  throw new Error('window.motePreview not defined')
}
